var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.37114e-06 0L0 100L100 100L100 -4.37114e-06L-4.37114e-06 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33133 75.9416C3.10617 77.7165 5.98435 77.7168 7.7595 75.9413L49.9989 33.701L92.2405 75.9416C94.0155 77.7165 96.8935 77.7168 98.6685 75.9413C100.443 74.1662 100.443 71.2883 98.6685 69.5131L53.213 24.0585C52.3605 23.206 51.2045 22.7275 49.9989 22.7275C48.7934 22.7275 47.6371 23.2065 46.7849 24.059L1.33163 69.5134C-0.443827 71.2883 -0.443827 74.1665 1.33133 75.9416Z",
    fill: "#FFC0CB"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_52_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_52_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -13,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.37114e-06 -13L0 87L100 87L100 -13L-4.37114e-06 -13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_52_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33133 62.9416C3.10617 64.7165 5.98435 64.7168 7.7595 62.9413L49.9989 20.701L92.2405 62.9416C94.0155 64.7165 96.8935 64.7168 98.6685 62.9413C100.443 61.1662 100.443 58.2883 98.6685 56.5131L53.213 11.0585C52.3605 10.206 51.2045 9.72751 49.9989 9.72751C48.7934 9.72751 47.6371 10.2065 46.7849 11.059L1.33163 56.5134C-0.443827 58.2883 -0.443827 61.1665 1.33133 62.9416Z",
    fill: "#87CEEB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0 100) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_52_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0 87) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.6eab42c74d1aba69938c58608520a464.svg";
export { ForwardRef as ReactComponent };